import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/api/client";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(""); setMsg("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message || "Check your inbox for a reset link.");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-neutral-100 flex items-center justify-center p-6">
      <form onSubmit={handleSubmit} className="w-full max-w-md space-y-6 fade-up border border-slate-800 rounded-2xl p-10 bg-slate-900/60">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500 mb-2">— Recovery</p>
          <h2 className="font-serif text-3xl text-sky-100">Reset password</h2>
          <p className="text-sm text-neutral-400 mt-2">Enter the email you used. If it exists, we'll send a reset link.</p>
        </div>
        {msg && <div data-testid="fp-success" className="border border-emerald-500/40 bg-emerald-500/5 text-emerald-300 px-4 py-2.5 text-sm rounded">{msg}</div>}
        {error && <div className="border border-red-500/40 bg-red-500/5 text-red-300 px-4 py-2.5 text-sm rounded">{error}</div>}
        <div>
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 block mb-2">Email</label>
          <input
            data-testid="input-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-transparent border-b border-slate-700 focus:border-sky-400 py-3 text-sky-50 outline-none transition"
          />
        </div>
        <button
          data-testid="btn-send-reset"
          type="submit"
          disabled={loading}
          className="w-full py-3 bg-sky-400 hover:bg-sky-300 text-slate-950 font-medium rounded-md disabled:opacity-60 transition"
        >
          {loading ? "Sending…" : "Send reset link"}
        </button>
        <div className="text-sm text-neutral-500">
          <Link to="/login" className="text-sky-300 border-b border-sky-400/40">← Back to sign in</Link>
        </div>
      </form>
    </div>
  );
}
